import {
	Button,
	Dialog,
	DialogBody,
	DialogSurface,
	DialogTitle,
	DialogTrigger,
	DialogContent,
	Title2,
	DialogOpenChangeEvent,
	DialogOpenChangeData
} from '@fluentui/react-components';
import { Dismiss24Regular } from '@fluentui/react-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { VideoGame } from '../../Api/Games/types';
import PlatformLibrary from '../../Media/PlatformLibrary';
import { Platform } from '../../Media/Types';

export interface AddPlayerGameModalProps {
	showModal: boolean;
	setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
	platform: Platform;
	playerGames: VideoGame[] | undefined;
}

const AddPlayerGameModal = (props: AddPlayerGameModalProps) => {
	return (
		<Dialog
			open={props.showModal}
			onOpenChange={(
				_event: DialogOpenChangeEvent,
				data: DialogOpenChangeData
			) => {
				props.setShowModal(data.open);
			}}
		>
			<DialogSurface>
				<DialogBody>
					<DialogTitle
						action={
							<DialogTrigger action='close'>
								<Button
									appearance='subtle'
									aria-label='close'
									icon={<Dismiss24Regular />}
								/>
							</DialogTrigger>
						}
					>
						<div style={{ display: 'flex', alignItems: 'center' }}>
							<FontAwesomeIcon
								style={{ paddingRight: '5px' }}
								icon={props.platform.FaIconName}
							/>
							<Title2>{props.platform.name} Games</Title2>
						</div>
					</DialogTitle>
					<DialogContent>
						<PlatformLibrary
							platform={props.platform}
							currentPlayersLibrary={props.playerGames}
						/>
					</DialogContent>
				</DialogBody>
			</DialogSurface>
		</Dialog>
	);
};

export default AddPlayerGameModal;
